import { Camera, Film, Headphones } from "lucide-react";
import { IMAGES, imgUrl } from "@/data/content";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";

const FORMATS = [
  { label: "Photo Essays", icon: Camera, image: IMAGES.ocean, alt: "Atlantic ocean surface" },
  { label: "Documentary Film", icon: Film, image: IMAGES.people, alt: "Community members gathered together" },
  { label: "Audio Stories", icon: Headphones, image: IMAGES.caribbeanStreet, alt: "Street scene in the Caribbean" },
];

export default function Multimedia() {
  return (
    <section id="multimedia" data-testid="multimedia-section" className="bg-sand py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <SectionHeading
          chapter="09"
          kicker="Multimedia"
          title="The Atlantic, Seen and Heard"
          copy="Documentary photography, film and audio from both sides of the ocean. Research and reporting in development."
        />
        <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-3">
          {FORMATS.map((f, i) => (
            <Reveal key={f.label} delay={i * 0.08}>
            <figure data-testid={`multimedia-tile-${f.label.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="group relative overflow-hidden">
              <img
                src={imgUrl(f.image, 800)}
                alt={f.alt}
                loading="lazy"
                className="aspect-[3/4] w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <figcaption className="absolute inset-x-0 bottom-0 flex items-center gap-3 bg-gradient-to-t from-atlantic/90 to-transparent p-6 pt-16">
                <f.icon size={16} className="text-gold" />
                <span className="font-serif text-lg text-white">{f.label}</span>
              </figcaption>
            </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
